<div fxLayout="column" fxFlexFill *ngIf="!loader">

    <div class="divider layout-padd-2 title-filter-date" ngClass.xs="layout-padd-5" #pageTitle>

        <span class="mat-title">MES RESERVATIONS</span>

        <div fxLayoutAlign="center center" class="filter-date-vignette primary clicked" (click)="this.filterDateAnimFlag = !this.filterDateAnimFlag" fxHide fxShow.xs>
            <i class="material-icons" *ngIf="!filterDateAnimFlag" style="color:white;">date_range</i>
            <i class="material-icons" *ngIf="filterDateAnimFlag" style="color:white;">keyboard_arrow_up</i>
        </div>

    </div>

    <div class="divider layout-padd-2" fxHide.xs>
        <app-filter-date-from-to [type]="'bookings'" (setDataEvent)="setBookings($event)" (setLoaderEvent)='setBookingLoader($event)'>
        </app-filter-date-from-to>
    </div>

    <div [@toggleFilterDate]="getToggleFilterDate" class="cont-filter-date-fix" [ngStyle]="{'top.px': titlePositionTop}" fxHide fxShow.xs>
        <div class="layout-padd-2">
            <app-filter-date-from-to [type]="'bookings'" (setDataEvent)="setBookings($event)" (setLoaderEvent)='setBookingLoader($event)'>
            </app-filter-date-from-to>
        </div>
    </div>

    <div fxFlex class="scrolled">

        <div class="scrolled-y">

            <table mat-table [dataSource]="dataSource" class="full-w clicked" ngClass.xs="fix-w-table" matSort>

                <ng-container matColumnDef="id_booking_level">

                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Statut </th>
                    <td mat-cell *matCellDef="let booking">

                        <div fxLayout="row" fxLayoutAlign="start center ">
                            <mat-chip-list aria-label="booking level">
                                <mat-chip selected [ngStyle]="{background: booking.level.color}">{{booking.level.name | uppercase}}</mat-chip>
                            </mat-chip-list>
                            <div style="padding-left: 8px;">
                                <i class="fas fa-barcode " *ngIf="booking.level.id>0" (click)="dialogService.openRefBookingDial(booking)" angulartics2On="click" angularticsAction="openBookingRef" angularticsCategory="clientBookings"></i>
                            </div>
                        </div>

                    </td>
                </ng-container>

                <ng-container matColumnDef="point_of_sale">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Point de vente </th>
                    <td mat-cell *matCellDef="let booking">
                        {{booking.point_of_sale.denomination}}
                    </td>
                </ng-container>

                <ng-container matColumnDef="date_reservation">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Date </th>
                    <td mat-cell *matCellDef="let booking">
                        {{booking.date_execution | dateFilter:"DD-MM-YYYY"}}
                    </td>
                </ng-container>

                <ng-container matColumnDef="hour_execution">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Heure </th>
                    <td mat-cell *matCellDef="let booking">
                        {{booking.hour_execution }}
                    </td>
                </ng-container>

                <ng-container matColumnDef="n_people">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Couvert(s) </th>
                    <td mat-cell *matCellDef="let booking">
                        {{booking.n_people }} </td>
                </ng-container>

                <ng-container matColumnDef="comment">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Commentaire </th>
                    <td mat-cell *matCellDef="let booking">
                        {{booking.comment}} </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

            </table>

            <div fxLayoutAlign="center center" class="layout-padd" *ngIf="!reservationLoader && !loader && dataSource.data.length < 1">
                <span class="mat-subheading-1">Aucune réservation trouvée</span>
            </div>

            <app-popup-loader [flagLoading]="reservationLoader" [size]="30" [statusMessage]="'loaderBooking'|translate" [type]="'line'"></app-popup-loader>

        </div>

        <mat-paginator [pageSizeOptions]="[10, 20, 50, 100]" showFirstLastButtons></mat-paginator>

    </div>

</div>

<app-popup-loader [flagLoading]="loader" [size]="30" [statusMessage]="'loaderBooking'|translate">
</app-popup-loader>